/**
 * Converts cart total to INR paise for Razorpay Orders API.
 * Treats `totalAmount` as rupees when your cart is INR; for other currencies, replace
 * with a server-side FX conversion before creating the order.
 */
export function cartTotalToRazorpayPaise(totalAmount: number | undefined): number {
  const n = Number(totalAmount ?? 0)
  return Math.max(100, Math.round(n * 100))
}
